import { render, staticRenderFns } from "./PayersProperties.vue?vue&type=template&id=43421762&scoped=true"
import script from "./PayersProperties.vue?vue&type=script&lang=js"
export * from "./PayersProperties.vue?vue&type=script&lang=js"
import style0 from "./PayersProperties.vue?vue&type=style&index=0&id=43421762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43421762",
  null
  
)

export default component.exports